// extracted by mini-css-extract-plugin
export default {"productDescription":"l2-z","featuredDescription":"m2-z","description":"n2-z","more":"o2-z","brandLogo":"p2-z","descriptionSku":"q2-z"};